import { type EventsAction, EventsActionNames } from './actions';

import type { Events, StartEndDateRange } from '@cobliteam/common-types';

import {
  type WebData,
  webDataError,
  webDataFetching,
  webDataNotAsked,
  webDataSuccess,
} from '@cobliteam/api-lib';

import { rootReducer } from '../HOR';

export interface EventsInfoTabState {
  eventsWebData: WebData<Events[]>;
  selectedEventsDateRange: StartEndDateRange;
  reportWebData: WebData<void>;
  eventsList: Events[];
}

export const eventsInfoInitialState: EventsInfoTabState = {
  eventsWebData: webDataNotAsked(),
  selectedEventsDateRange: null,
  reportWebData: webDataNotAsked(),
  eventsList: [],
};

const eventsInfoReducer = (
  state: EventsInfoTabState = eventsInfoInitialState,
  action: EventsAction
): EventsInfoTabState => {
  if (!(action.type in EventsActionNames)) {
    return state;
  }

  switch (action.type) {
    case EventsActionNames.LOAD_EVENTS_INFO_SUCCEEDED:
      return {
        ...state,
        eventsWebData: webDataSuccess(action.payload),
      };

    case EventsActionNames.LOAD_EVENTS_INFO_REQUEST:
      return {
        ...state,
        eventsWebData: webDataFetching(),
        selectedEventsDateRange: {
          start: action.payload.startDate,
          end: action.payload.endDate,
        },
      };

    case EventsActionNames.LOAD_EVENTS_INFO_FAILED:
      return {
        ...state,
        eventsWebData: webDataError(),
      };

    default:
      return state;
  }
};

export const eventsInfoTabReducer = rootReducer(
  [eventsInfoReducer],
  eventsInfoInitialState
);
